module.exports = __webpack_public_path__ + "h5assets/img/banner.a79cd5a.png";